// extracted by mini-css-extract-plugin
module.exports = {"grid":"Instructions_grid__3yq6f","step":"Instructions_step__3UpQI","arrow":"Instructions_arrow__1LoGi"};